export default __webpack_public_path__ + "static/media/optimism_square_logo.ce1b5342.svg";